import * as swcHelpers from '@swc/helpers';

const mapAndMergeApplePayShippingContactWithBillingContact = (shippingContact, billingContact)=>{
    var ref, ref1, ref2;
    // Apple Pay doesn't provide a company field.
    // The docs suggest to use the familyname as company name: https://developer.apple.com/documentation/passkit/pkpaymentrequest/displaying_a_read-only_pickup_address
    const isOnlyCompanyNameProvided = !!shippingContact.familyName && !shippingContact.givenName;
    const isContactProvidedExplicityInPaymentSheet = !!shippingContact.givenName && !!shippingContact.familyName;
    const configurableFields = {
        firstName: '',
        lastName: ''
    };
    if (isContactProvidedExplicityInPaymentSheet) {
        configurableFields.firstName = shippingContact.givenName || '';
        configurableFields.lastName = shippingContact.familyName || '';
    } else {
        configurableFields.firstName = billingContact.givenName || '';
        configurableFields.lastName = billingContact.familyName || '';
    }
    if (isOnlyCompanyNameProvided) {
        configurableFields.company = shippingContact.familyName;
    }
    return swcHelpers.objectSpread({
        streetName: ((ref = shippingContact.addressLines) === null || ref === void 0 ? void 0 : ref[0]) || '',
        streetNumber: ((ref1 = shippingContact.addressLines) === null || ref1 === void 0 ? void 0 : ref1[1]) || '',
        additionalStreetInfo: ((ref2 = shippingContact.addressLines) === null || ref2 === void 0 ? void 0 : ref2[2]) || '',
        postalCode: (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.postalCode) || '',
        city: (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.locality) || '',
        countryCode: shippingContact.countryCode || ''
    }, configurableFields, shippingContact.phoneNumber ? {
        phone: shippingContact.phoneNumber
    } : {}, (shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.subAdministrativeArea) ? {
        region: shippingContact === null || shippingContact === void 0 ? void 0 : shippingContact.subAdministrativeArea
    } : {});
};

export { mapAndMergeApplePayShippingContactWithBillingContact };
//# sourceMappingURL=merge-apple-pay-contact-and-billing-address.js.map
